import { render, staticRenderFns } from "./createCustomerSegment.vue?vue&type=template&id=69a83210&scoped=true&"
import script from "./createCustomerSegment.vue?vue&type=script&lang=js&"
export * from "./createCustomerSegment.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./createCustomerSegment.vue?vue&type=style&index=1&id=69a83210&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a83210",
  null
  
)

export default component.exports